const BASE = process.env.REACT_APP_API_URL || '/api';

export const getToken = () => localStorage.getItem('ap_token');
export const setToken = (t) => localStorage.setItem('ap_token', t);
export const removeToken = () => localStorage.removeItem('ap_token');
export const getDeviceToken = () => localStorage.getItem('ap_device_token');
export const setDeviceToken = (t) => localStorage.setItem('ap_device_token', t);

async function apiForm(endpoint, formData) {
  const token = getToken();
  const res = await fetch(`${BASE}${endpoint}`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Errore ${res.status}`);
  return data;
}

async function api(endpoint, options = {}) {
  const token = getToken();
  const res = await fetch(`${BASE}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Errore ${res.status}`);
  return data;
}

export const auth = {
  checkPhone:(telefono) => api('/auth/check-phone', { method: 'POST', body: { telefono } }),
  otpSend:   (telefono) => api('/auth/otp/send',   { method: 'POST', body: { telefono } }),
  otpVerify: (telefono, codice) => api('/auth/otp/verify', { method: 'POST', body: { telefono, codice } }),
  otpLogin: async (telefono, codice) => {
    const data = await api('/auth/otp-login', { method: 'POST', body: { telefono, codice } });
    if (data.token) setToken(data.token);
    return data;
  },
  registerOtp: async (body) => {
    const data = await api('/auth/register-otp', { method: 'POST', body });
    if (data.token) setToken(data.token);
    return data;
  },
  register: async (body) => {
    const data = await api('/auth/register', { method: 'POST', body });
    if (data.token) setToken(data.token);
    return data;
  },
  login: async (body) => {
    const data = await api('/auth/login', { method: 'POST', body });
    if (data.token) setToken(data.token);
    return data;
  },
  me: () => api('/auth/me'),
  agenzie: () => api('/auth/agenzie-pubbliche'),
  registraOperatore: (body) => api('/auth/registra-operatore', { method: 'POST', body }),
  logout: () => { removeToken(); },
  registerDevice: async () => {
    const data = await api('/auth/register-device', { method: 'POST' });
    if (data.device_token) setDeviceToken(data.device_token);
    return data;
  },
  deviceLogin: async () => {
    const device_token = getDeviceToken();
    if (!device_token) throw new Error('Nessun device token');
    const data = await api('/auth/device-login', { method: 'POST', body: { device_token } });
    if (data.token) setToken(data.token);
    return data;
  },
  accettaTC: (body) => api('/auth/tc/accetta', { method: 'POST', body }),
};

export const familiari = {
  sendOtp:  (telefono) => api('/clienti/familiari/send-otp', { method: 'POST', body: { telefono } }),
  verifica: (idx, codice, telefono) => api('/clienti/familiari/verifica', { method: 'POST', body: { idx, codice, telefono } }),
  aggiorna: (idx, data) => api(`/clienti/familiari/${idx}`, { method: 'PATCH', body: data }),
  rimuovi:  (idx) => api(`/clienti/familiari/${idx}`, { method: 'DELETE' }),
};

export const interventi = {
  richiedi:      (body) => api('/interventi', { method: 'POST', body }),
  accetta:       (id)   => api(`/interventi/${id}/accetta`, { method: 'POST' }),
  aggiornaStato: (id, stato) => api(`/interventi/${id}/stato`, { method: 'PATCH', body: { stato } }),
  aggiungiNota:  (id, body)  => api(`/interventi/${id}/diario`, { method: 'POST', body }),
  valuta:        (id, body)  => api(`/interventi/${id}/valuta`, { method: 'POST', body }),
  cancella:      (id)   => api(`/interventi/${id}/cancella`, { method: 'POST' }),
  concludi:       (id)   => api(`/interventi/${id}/concludi`, { method: 'POST' }),
  estendi:       (id)   => api(`/interventi/${id}/estendi`, { method: 'POST' }),
  concludiAuto:  (id)   => api(`/interventi/${id}/auto-concludi`, { method: 'POST' }),
  lista:         ()     => api('/interventi'),
  dettaglio:      (id)   => api(`/interventi/${id}`),
};

export const operatori = {
  setOnline:    (online) => api('/operatori/stato', { method: 'PATCH', body: { online } }),
  setStato:     (stato)  => api('/operatori/stato', { method: 'PATCH', body: { stato } }),
  aggiornaGPS:  (lat, lng) => api('/operatori/gps', { method: 'PATCH', body: { lat, lng } }),
  profilo:        () => api('/operatori/me'),
  stats:          () => api('/operatori/stats'),
  compensi:       () => api('/operatori/compensi'),
  pending:        () => api('/interventi/pending'),
  attivo:         () => api('/operatori/attivo'),
  storicoMensile: () => api('/operatori/storico-mensile'),
  pushSubscribe:  (sub) => api('/operatori/push-subscribe', { method: 'POST', body: sub }),
  pushUnsubscribe:(endpoint) => api('/operatori/push-subscribe', { method: 'DELETE', body: { endpoint } }),
};

export const clienti = {
  profilo:           () => api('/clienti/me'),
  storico:           () => api('/clienti/storico'),
  attivo:            () => api('/clienti/attivo'),
  messaggi:          () => api('/clienti/messaggi'),
  leggiMessaggio:    (id) => api(`/clienti/messaggi/${id}/letto`, { method: 'PATCH' }),
  aggiornaGPS:       (lat, lng) => api('/clienti/gps', { method: 'PATCH', body: { lat, lng } }),
  aggiornaFamiliari: (familiari) => api('/clienti/familiari', { method: 'PATCH', body: { familiari } }),
  eliminaAccount:    () => api('/clienti/me', { method: 'DELETE' }),
  news:              () => api('/clienti/news'),
  pushSubscribe:     (sub) => api('/clienti/push-subscribe', { method: 'POST', body: sub }),
};

export const pagamenti = {
  setupIntent:           ()                    => api('/pagamenti/setup-intent', { method: 'POST' }),
  confermaCarta:         (payment_method_id)   => api('/pagamenti/conferma-carta', { method: 'POST', body: { payment_method_id } }),
  confermaCartaStripe:   (payment_method_id)   => api('/pagamenti/conferma-carta', { method: 'POST', body: { payment_method_id } }),
  attivaAbbonamento:     ()                    => api('/pagamenti/abbonamento', { method: 'POST' }),
  abbonamento:           ()                    => api('/pagamenti/abbonamento', { method: 'POST' }),
  cancellaAbbonamento:   ()                    => api('/pagamenti/abbonamento', { method: 'DELETE' }),
  situazione:            ()                    => api('/pagamenti/situazione'),
  syncFamiliari:         ()                    => api('/pagamenti/sync-familiari', { method: 'POST' }),
  attivaPayPerCall:      ()                    => api('/pagamenti/attiva-pay-per-call', { method: 'POST' }),
};

export const referral = {
  checkCodice: (codice) => api(`/referral/check/${codice}`),
};

export const admin = {
  dashboard:        () => api('/admin/dashboard'),
  info:             () => api('/admin/info'),
  grafici:          () => api('/admin/grafici'),
  operatori:        () => api('/admin/operatori'),
  creaOperatore:    (body) => api('/admin/operatori', { method: 'POST', body }),
  aggiornaCompenso: (id, compenso) => api(`/admin/operatori/${id}/compenso`, { method: 'PATCH', body: { compenso } }),
  aggiornaOperatore:(id, body) => api(`/admin/operatori/${id}`, { method: 'PATCH', body }),
  statoOperatore:   (id, body) => api(`/admin/operatori/${id}/stato`, { method: 'PATCH', body }),
  eliminaOperatore: (id) => api(`/admin/operatori/${id}`, { method: 'DELETE' }),
  approvaOperatore:   (id) => api(`/admin/operatori/${id}/approva`, { method: 'POST' }),
  rifiutaOperatore:   (id) => api(`/admin/operatori/${id}/rifiuta`, { method: 'DELETE' }),
  accettazioniOp:     (id) => api(`/admin/operatori/${id}/accettazioni`),
  aggiornaProfilo:  (id, body) => api(`/admin/operatori/${id}/profilo`, { method: 'PATCH', body }),
  uploadFoto:       (id, file) => { const fd = new FormData(); fd.append('foto', file); return apiForm(`/admin/operatori/${id}/foto`, fd); },
  aggiornaAgenziaAdmin: (body) => api('/admin/agenzia', { method: 'PATCH', body }),
  clienti:          () => api('/admin/clienti'),
  creditiOp:        (id, body) => api(`/admin/clienti/${id}/crediti`, { method: 'POST', body }),
  emailCliente:     (id, body) => api(`/admin/clienti/${id}/email`, { method: 'POST', body }),
  creditiLog:       () => api('/admin/crediti-log'),
  report:           (mese, anno) => api(`/admin/report?mese=${mese}&anno=${anno}`),
  liquida:          (id) => api(`/admin/liquidazione/${id}`, { method: 'POST' }),
  demo:             () => api('/admin/demo'),
  demoCancella:     () => api('/admin/demo', { method: 'DELETE' }),
  storico:          (p = {}) => api('/admin/storico-interventi?' + new URLSearchParams(Object.fromEntries(Object.entries(p).filter(([,v])=>v!==''&&v!=null)))),
  storicoProgammati:(p = {}) => api('/admin/programmati?' + new URLSearchParams(Object.fromEntries(Object.entries(p).filter(([,v])=>v!==''&&v!=null)))),
  clienteInterventi:(id) => api(`/admin/clienti/${id}/interventi`),
};

export const superadmin = {
  dashboard:          () => api('/superadmin/dashboard'),
  agenzie:            () => api('/superadmin/agenzie'),
  dettaglioAgenzia:   (id) => api(`/superadmin/agenzie/${id}`),
  creaAgenzia:        (body) => api('/superadmin/agenzie', { method: 'POST', body }),
  aggiornaLicenza:    (id, body) => api(`/superadmin/agenzie/${id}/licenza`, { method: 'PATCH', body }),
  aggiornaAgenzia:    (id, body) => api(`/superadmin/agenzie/${id}`, { method: 'PATCH', body }),
  cambiaPasswordAdmin:(id, body) => api(`/superadmin/agenzie/${id}/admin-password`, { method: 'PATCH', body }),
  eliminaAgenzia:     (id) => api(`/superadmin/agenzie/${id}`, { method: 'DELETE' }),
  cancellaStorico:    (id) => api(`/superadmin/agenzie/${id}/storico`, { method: 'DELETE' }),
  reportAgenzia:      (id, mese, anno) => api(`/superadmin/agenzie/${id}/report?mese=${mese}&anno=${anno}`),
  demo:               () => api('/superadmin/demo'),
  demoCancellaAll:    () => api('/superadmin/demo', { method: 'DELETE' }),
  richieste:          () => api('/superadmin/richieste'),
  aggiornaRichiesta:  (id, body) => api(`/superadmin/richieste/${id}`, { method: 'PATCH', body }),
  creditiLog:         (agenzia_id) => api(`/superadmin/crediti-log${agenzia_id ? `?agenzia_id=${agenzia_id}` : ''}`),
  storico:            (p = {}) => api('/superadmin/storico-interventi?' + new URLSearchParams(Object.fromEntries(Object.entries(p).filter(([,v])=>v!==''&&v!=null)))),
  aggiornaPiano:      (id, body) => api(`/superadmin/agenzie/${id}/piano`, { method: 'PATCH', body }),
  cerca:              (q) => api(`/superadmin/cerca?q=${encodeURIComponent(q)}`),
  clienti:            () => api('/superadmin/clienti'),
  clienteDettaglio:   (id) => api(`/superadmin/clienti/${id}/dettaglio`),
  clienteModifica:    (id, body) => api(`/superadmin/clienti/${id}/modifica`, { method: 'PATCH', body }),
  clienteSospendi:    (id, sospendi) => api(`/superadmin/clienti/${id}/sospendi`, { method: 'PATCH', body: { sospendi } }),
  clienteElimina:     (id) => api(`/superadmin/clienti/${id}`, { method: 'DELETE' }),
  rimborso:           (tipo, id, importo_cents) => api('/superadmin/clienti/rimborso', { method: 'POST', body: { tipo, id, importo_cents } }),
  superUserToggle:    (id, attivo) => api(`/superadmin/clienti/${id}/super-user`, { method: 'PATCH', body: { attivo } }),
  abbonamentoRegalo:  (id, mesi) => api(`/superadmin/clienti/${id}/abbonamento-regalo`, { method: 'POST', body: { mesi } }),
  revocaRegalo: (id) => api(`/superadmin/clienti/${id}/regalo`, { method: 'DELETE' }),
  messaggioCliente:   (id, testo) => api(`/superadmin/clienti/${id}/messaggio`, { method: 'POST', body: { testo } }),
  eliminaMessaggio:   (id) => api(`/superadmin/messaggi/${id}`, { method: 'DELETE' }),
  stressTestStart:    (body) => api('/superadmin/stress-test/start', { method: 'POST', body }),
  stressTestCleanup:  () => api('/superadmin/stress-test/cleanup', { method: 'DELETE' }),
  stressTestStatus:   () => api('/superadmin/stress-test/status'),
  affiliati:          () => api('/superadmin/affiliati'),
  creaAffiliate:      (body) => api('/superadmin/affiliati', { method: 'POST', body }),
  aggiornaAffiliate:  (id, body) => api(`/superadmin/affiliati/${id}`, { method: 'PUT', body }),
  eliminaAffiliate:   (id) => api(`/superadmin/affiliati/${id}`, { method: 'DELETE' }),
  feedbackLanding:    () => api('/superadmin/feedback-landing'),
  creaFeedback:       (body) => api('/superadmin/feedback-landing', { method: 'POST', body }),
  aggiornaFeedback:   (id, body) => api(`/superadmin/feedback-landing/${id}`, { method: 'PUT', body }),
  eliminaFeedback:    (id) => api(`/superadmin/feedback-landing/${id}`, { method: 'DELETE' }),
  // News
  news:               () => api('/superadmin/news'),
  cercaClienteNews:   (q) => api(`/superadmin/news/cerca-cliente?q=${encodeURIComponent(q)}`),
  creaNews:           (body) => api('/superadmin/news', { method: 'POST', body }),
  aggiornaNews:       (id, body) => api(`/superadmin/news/${id}`, { method: 'PUT', body }),
  eliminaNews:        (id) => api(`/superadmin/news/${id}`, { method: 'DELETE' }),
  tcLog:              (params) => api(`/superadmin/tc-log?${new URLSearchParams(params).toString()}`),
  // Referral
  referralStats:      () => api('/superadmin/referral/stats'),
  referralList:       (cerca) => api(`/superadmin/referral${cerca ? `?cerca=${encodeURIComponent(cerca)}` : ''}`),
  referralDettaglio:  (id) => api(`/superadmin/referral/${id}`),
  referralPaga:       (id, body) => api(`/superadmin/referral/${id}/paga`, { method: 'POST', body }),
  referralToggle:     (id) => api(`/superadmin/referral/${id}/toggle`, { method: 'PATCH' }),
  accettazioniOperatori: () => api('/superadmin/accettazioni-operatori'),
  countClientiSenzaAgenzia: () => api('/superadmin/fix-clienti-senza-agenzia'),
  fixClientiSenzaAgenzia: () => api('/superadmin/fix-clienti-senza-agenzia', { method: 'POST' }),
  resetInterventiOperatore: (id) => api(`/superadmin/operatori/${id}/reset-interventi`, { method: 'DELETE' }),
};

export const business = {
  inviaRichiesta:       (body) => api('/business/richiesta', { method: 'POST', body }),
  miaRichiesta:         ()     => api('/business/mia'),
  // admin
  adminRichieste:       ()     => api('/business/admin'),
  adminBadge:           ()     => api('/business/admin/badge'),
  adminAggiornaStato:   (id, body) => api(`/business/admin/${id}`, { method: 'PATCH', body }),
  // superadmin
  superadminRichieste:  ()     => api('/business/superadmin'),
  superadminBadge:      ()     => api('/business/superadmin/badge'),
  superadminAggiornaStato: (id, body) => api(`/business/superadmin/${id}`, { method: 'PATCH', body }),
};

// ── BUSINESS PORTAL (token separato bp_token) ─────────────────────────────
const getBpToken = () => localStorage.getItem('bp_token');
async function bpApi(endpoint, options = {}) {
  const token = getBpToken();
  const res = await fetch(`${BASE}/business-portal${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Errore ${res.status}`);
  return data;
}
export const businessPortal = {
  // auth
  otpRequest:        (telefono)  => bpApi('/otp-request', { method:'POST', body:{ telefono } }),
  otpVerify:         (telefono, codice) => bpApi('/otp-verify', { method:'POST', body:{ telefono, codice } }),
  me:                ()          => bpApi('/me'),
  // richieste
  creaRichiesta:     (body)      => bpApi('/richieste', { method:'POST', body }),
  mieRichieste:      ()          => bpApi('/richieste'),
  modificaRichiesta: (id, body)  => bpApi(`/richieste/${id}`, { method:'PATCH', body }),
  cancellaRichiesta: (id)        => bpApi(`/richieste/${id}`, { method:'DELETE' }),
  rispondiPreventivo:(id, accetta) => bpApi(`/richieste/${id}/preventivo-risposta`, { method:'PATCH', body:{ accetta } }),
  // admin agenzia (usa token normale)
  adminRichieste:    ()          => api('/business-portal/admin/richieste'),
  adminPreventivo:   (id, body)  => api(`/business-portal/admin/richieste/${id}/preventivo`, { method:'PATCH', body }),
  adminStato:        (id, body)  => api(`/business-portal/admin/richieste/${id}/stato`, { method:'PATCH', body }),
  // superadmin (usa token normale)
  superadminUtenti:  ()          => api('/business-portal/superadmin/utenti'),
  superadminCreaUtente: (body)   => api('/business-portal/superadmin/utenti', { method:'POST', body }),
  superadminAggUtente: (id, body)=> api(`/business-portal/superadmin/utenti/${id}`, { method:'PATCH', body }),
  superadminRichieste: ()        => api('/business-portal/superadmin/richieste'),
};

export const pubblico = {
  feedbackLanding: () => {
    const base = (process.env.REACT_APP_API_URL || window.location.origin + '/api').replace(/\/api$/, '/api');
    return fetch(`${base}/public/feedback-landing`).then(r => r.json());
  },
};

export const richieste = {
  inviaAgenzia: (body) => api('/richieste/agenzia', { method: 'POST', body }),
};

export const programmati = {
  crea:     (body)  => api('/programmati',               { method: 'POST', body }),
  mie:      ()      => api('/programmati/mie'),
  paga:     (id)    => api(`/programmati/${id}/paga`,    { method: 'POST', body: {} }),
  cancella: (id)    => api(`/programmati/${id}`,         { method: 'DELETE' }),
  // operatore
  lista:    ()      => api('/programmati/operatore'),
  accetta:  (id)    => api(`/programmati/${id}/accetta`, { method: 'POST', body: {} }),
  rifiuta:  (id)    => api(`/programmati/${id}/rifiuta`, { method: 'POST', body: {} }),
  completa: (id)    => api(`/programmati/${id}/completa`,{ method: 'POST', body: {} }),
};

export const reportInterventi = {
  invia:          (interventoId, body) => api(`/report/${interventoId}`, { method: 'POST', body }),
  listaAdmin:     (params = {})        => api('/report/admin?' + new URLSearchParams(params).toString()),
  badgeAdmin:     ()                   => api('/report/admin/badge'),
  listaSuperadmin:(params = {})        => api('/report/superadmin?' + new URLSearchParams(params).toString()),
  badgeSuperadmin:()                   => api('/report/superadmin/badge'),
};

export const messaggi = {
  // admin
  lista:    ()           => api('/messaggi'),
  invia:    (oggetto, testo) => api('/messaggi', { method:'POST', body:{ oggetto, testo } }),
  modifica: (id, testo)  => api(`/messaggi/${id}`, { method:'PATCH', body:{ testo } }),
  cancella: (id)         => api(`/messaggi/${id}`, { method:'DELETE' }),
  segnaLetto: (id)       => api(`/messaggi/${id}/letto`, { method:'POST' }),
  // superadmin
  listaSuperadmin:  ()          => api('/messaggi/superadmin'),
  badgeSuperadmin:  ()          => api('/messaggi/superadmin/badge'),
  segnaLettoSuper:  (id)        => api(`/messaggi/superadmin/${id}/letto`, { method:'POST' }),
  rispondi:         (id, testo) => api(`/messaggi/superadmin/${id}/rispondi`, { method:'POST', body:{ testo } }),
  modificaRisposta: (id, testo) => api(`/messaggi/superadmin/risposta/${id}`, { method:'PATCH', body:{ testo } }),
  cancellaRisposta: (id)        => api(`/messaggi/superadmin/risposta/${id}`, { method:'DELETE' }),
  cancellaSuper:    (id)        => api(`/messaggi/superadmin/${id}`, { method:'DELETE' }),
};

export const fatturazione = {
  info:          ()     => api('/fatturazione'),
  setupIntent:   ()     => api('/fatturazione/setup-intent',   { method:'POST', body:{} }),
  confermaCarta: (pm)   => api('/fatturazione/conferma-carta', { method:'POST', body:{ payment_method_id: pm } }),
  cambiaLivello: (opId, livello) => api(`/fatturazione/operatori/${opId}/livello`, { method:'PATCH', body:{ livello } }),
  // superadmin
  tutteAgenzie:  ()     => api('/fatturazione/superadmin'),
  logAgenzia:    (id)   => api(`/fatturazione/superadmin/${id}`),
};

export function creaWebSocket(onMessage, onOpen) {
  const WS = (process.env.REACT_APP_API_URL || window.location.origin)
    .replace('http', 'ws').replace('/api', '') + '/ws';
  const ws = new WebSocket(WS);
  ws.onopen = () => {
    setInterval(() => ws.readyState === 1 && ws.send(JSON.stringify({ tipo: 'ping' })), 30000);
    if (onOpen) onOpen(ws);
  };
  ws.onmessage = (e) => { try { onMessage(JSON.parse(e.data)); } catch {} };
  ws.onclose = () => setTimeout(() => creaWebSocket(onMessage, onOpen), 3000);
  return ws;
}

export function avviaGPS(ws, operatore_id, intervento_id) {
  if (!navigator.geolocation) return null;
  return navigator.geolocation.watchPosition(({ coords: { latitude: lat, longitude: lng } }) => {
    operatori.aggiornaGPS(lat, lng).catch(() => {});
    if (ws?.readyState === 1) ws.send(JSON.stringify({ tipo: 'gps_update', operatore_id, intervento_id, lat, lng }));
  }, null, { enableHighAccuracy: true, maximumAge: 5000 });
}
